'use client';

import { RotateCcw, XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

type Props = {
  message: string | null;
  /** Reintenta el cierre con el mismo `orderId`; ausente cuando el error no es reintentable. */
  onRetry?: () => void;
  /** Vuelve a elegir medio y cancela la orden del intento. */
  onBack: () => void;
  /** Cierra el modal sin seguir operando. */
  onClose: () => void;
  isPending?: boolean;
};

/** Error de cobro: la orden no se cerró, el pago fue rechazado o se agotó la espera. */
export function CheckoutErrorStep({ message, onRetry, onBack, onClose, isPending }: Props) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-6 px-4 py-20 text-center">
      <XCircle className="size-20 text-red-500" />
      <h3 className="text-2xl font-bold">No se pudo completar el cobro</h3>
      <p className="max-w-md text-base text-muted-foreground">
        {message ?? 'Revisá el estado del pedido antes de volver a intentarlo.'}
      </p>

      <div className="flex flex-col items-center gap-3 sm:flex-row">
        {onRetry ? (
          <>
            <Button type="button" className="h-11 rounded-full px-6" onClick={onRetry} disabled={isPending}>
              <RotateCcw className="mr-2 size-4" />
              Reintentar cobro
            </Button>
            <Button type="button" variant="outline" className="h-11 rounded-full px-6" onClick={onBack}>
              Cancelar y volver
            </Button>
          </>
        ) : (
          <>
            <Button type="button" className="h-11 rounded-full px-6" onClick={onBack}>
              Volver a elegir medio
            </Button>
            <Button type="button" variant="outline" className="h-11 rounded-full px-6" onClick={onClose}>
              Cerrar
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
